import * as React from "react";

import {
  PRESENTATION_SCROLL_ACTIONS,
  usePresenterForScroll,
} from "../../providers/presenter-for-scroll-provider";

import { scrollToJustAbove } from "../../scroll";

interface UseScrollToErrorInFormProps {
  formLogic: { [key: string]: any };
  form: { [key: string]: any };

  cssSelectorBase?: string;
  overrideScrollToCustomField?: () => string | undefined | null;
}

const buildSelector = (
  props: UseScrollToErrorInFormProps,
  elementSelectorFragment: string
) => `${props.cssSelectorBase || ""} ${elementSelectorFragment}`;

export const useScrollToErrorInForm = (
  props: UseScrollToErrorInFormProps
): void => {
  const { scrollActionToTake, onScrollAnimationBegin } =
    usePresenterForScroll();

  React.useEffect(() => {
    if (
      scrollActionToTake ===
      PRESENTATION_SCROLL_ACTIONS.SCROLL_TO_FORM_ERROR_FIELD
    ) {
      let scrollToThisElement: Element | null = null;

      if (!scrollToThisElement && props.overrideScrollToCustomField) {
        const customField = props.overrideScrollToCustomField();
        if (customField) {
          const selector = buildSelector(props, customField);
          const element = document.querySelector(selector);
          if (element) {
            scrollToThisElement = element;
          }
        }
      }

      Object.keys(props.formLogic).forEach((key) => {
        if (!scrollToThisElement) {
          const errorPropertyKey = `${key}Error`;
          const errorProperty = props.form[errorPropertyKey];
          if (errorProperty) {
            const selector = buildSelector(props, `.named-${key}`);
            const element = document.querySelector(selector);
            if (element) {
              scrollToThisElement = element;
            }
          }
        }
      });

      if (scrollToThisElement) {
        scrollToJustAbove(scrollToThisElement);
      }

      onScrollAnimationBegin();
    }
  }, [props, scrollActionToTake]);
};
